<template>
  <v-app id="inspire">
    <Header v-model="expandOnHover"   @toggleIconMenu="expandOnHover"></Header>

    <v-main >
    <v-container fluid class="page-wrapper">
      <router-view />
    </v-container>
  </v-main>
    <Sidebar :expand-on-hover.sync="expandOnHover"></Sidebar>

<!--     -->
<!--    <Footer></Footer> -->
    
  </v-app>

</template>

<script>

 import Header from './header/Header';
 import Sidebar from './sidebar/Sidebar';
 import AuthService from '@/services/auth-service'
 // import Customizer from './customizer/Customizer';
 import {mapMutations, mapState} from 'vuex';
 // import Footer from './footer/Footer';
  export default {
  name: 'Layout',

  components: {
    Header,
    Sidebar,
    // Footer,
    // Customizer
  },

  props: {
    source: String,
  },
  data: () => ({
    expandOnHover: false
  }),
  computed: {
      ...mapState(['Customizer_drawer']),
    },

    methods: {
      ...mapMutations({
        setCustomizerDrawer: 'SET_CUSTOMIZER_DRAWER',
      }),
    },

    async beforeCreate() {
      const data = await AuthService.user()

      const dataEntityPivit = data.entity
      const permissionsApi = data.roles[0].permissions
      const array = permissionsApi.map((n) => {
        return n.name
      })
      const Entity = data.entities.find((e) => {
        if (dataEntityPivit.id === e.id) {
          return e
        }
      })
      const dataEnti = data.entities
      let pivot = ''
      if (data.roles[0].name == 'Administrador' || data.roles[0].name == 'managers') {

        if (Entity == undefined || Entity.position_pivot == null) {
          pivot = data.roles[0].name
        } else {
          pivot = Entity.position_pivot
        }
      } else if(data.roles[0].name ==='Operadores') {
        pivot = Entity.position_pivot
      }
      const position = pivot.position == undefined ? data.roles[0].name : pivot.position[0]
      this.$store.dispatch('updatePermissionArray', array)
      this.$store.dispatch('updateUserID', data.id)
      this.$store.dispatch('updateUserName', data.shortname)
      this.$store.dispatch('updateUserAvatar', data.avatar)
      this.$store.dispatch('updateRole', data.roles[0].name)
      this.$store.dispatch('updateDefaultClient', data.client)
      this.$store.dispatch('updateUserClients', data.clients)
      this.$store.dispatch('updateUserEntity', dataEnti)
      this.$store.dispatch('updateUserPosition', position)
      this.$store.dispatch('updateUserPivot', pivot)

      this.$store.dispatch('updateUserEnti', dataEntityPivit)

    }
}
</script>

<style>

</style>